/**
 * BrandsFAQ.tsx — Gold Garage Door / Brands · Section 7/8
 * Navy · accordion FAQ + JSON-LD FAQPage schema (SEO rich result).
 * MOBILE: real <style> media query for padding.
 * 10WEB AI: keep <script type="application/ld+json"> exactly. Keep inline SVG + <style>.
 *    Wave dividers intentional — do NOT strip.
 */

import { useState } from "react";
const NAVY = "#081438";
const GOLD = "#F5A623";
const FAQS = [{
  q: "Do you only work on certain brands?",
  a: "No — we service every major garage-door brand in Australia, including B&D, Merlin, ATA, Centurion, Steel-Line, Gliderol, LiftMaster, Marantec, Grifco, Superlift, Hörmann and 4D Industrial. If it's a garage door, we can work on it."
}, {
  q: "Are you an authorised dealer for these brands?",
  a: "We're an independent Sydney repairer with deep, hands-on expertise across all of these brands. We use genuine parts wherever possible and service to manufacturer method, but we're not tied to any single brand — so our advice is always in your interest."
}, {
  q: "Can you fix my opener if I don't know the brand?",
  a: "Yes. Bring us the model number or send a photo and we'll identify it. Most openers have a brand and model printed on the motor housing — and our techs recognise the vast majority on sight."
}, {
  q: "Do you stock genuine remotes for my brand?",
  a: "We carry genuine remotes and keypads for the common brands — B&D, Merlin and ATA especially — and can program them on the spot. For rarer models we'll source the correct genuine unit."
}, {
  q: "My brand is discontinued — can you still help?",
  a: "Often yes. Many older systems can be repaired with current parts, or we can recommend a compatible modern opener or door. We'll always tell you honestly whether a repair or replacement is the smarter spend."
}, {
  q: "Does using your service void my manufacturer warranty?",
  a: "Servicing to manufacturer method with appropriate parts keeps your door's integrity intact. Our own work is also backed by a 1-Year Labour Warranty. If you have a specific manufacturer warranty concern, tell us and we'll work around it."
}];
function Item({
  f,
  open,
  onClick
}) {
  return <div style={{
    borderBottom: "1px solid rgba(255,255,255,0.1)"
  }}>
      <button onClick={onClick} style={{
      width: "100%",
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: "1.35rem 0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "1rem",
      textAlign: "left"
    }}>
        <span style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontWeight: 700,
        fontSize: "1.02rem",
        color: "#fff"
      }}>{f.q}</span>
        <span aria-hidden style={{
        flexShrink: 0,
        width: "28px",
        height: "28px",
        borderRadius: "50%",
        border: `1.5px solid ${GOLD}`,
        color: GOLD,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.2rem",
        transform: open ? "rotate(45deg)" : "none",
        transition: "transform 0.25s ease"
      }}>+</span>
      </button>
      <div style={{
      maxHeight: open ? "360px" : "0",
      overflow: "hidden",
      transition: "max-height 0.3s ease"
    }}>
        <p style={{
        fontFamily: "'Manrope', sans-serif",
        fontSize: "0.96rem",
        color: "rgba(255,255,255,0.72)",
        lineHeight: 1.7,
        paddingBottom: "1.35rem",
        margin: 0,
        maxWidth: "660px"
      }}>{f.a}</p>
      </div>
    </div>;
}
export default function BrandsFAQ() {
  const [open, setOpen] = useState(0);
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map(f => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.a
      }
    }))
  };
  return <section id="brands-faq" style={{
    background: `radial-gradient(ellipse at 70% 100%, #14254d 0%, ${NAVY} 55%)`,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5.5rem",
    paddingBottom: "5.5rem"
  }}>
      <style>{`@media (max-width: 560px){ #brands-faq{ padding-top: 3.5rem; padding-bottom: 3.5rem; } }`}</style>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schema)
    }} />

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}><filter id="grain-bfaq"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter><rect width="100%" height="100%" filter="url(#grain-bfaq)" /></svg>

      <div aria-hidden style={{
      position: "absolute",
      top: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      right: "-1rem",
      bottom: "2rem",
      fontSize: "11rem",
      fontWeight: 900,
      color: `${GOLD}0D`,
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      lineHeight: 1,
      userSelect: "none",
      pointerEvents: "none"
    }}>07</div>

      <div style={{
      maxWidth: "820px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        <div style={{
        textAlign: "center",
        marginBottom: "2.5rem"
      }}>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD,
          textTransform: "uppercase"
        }}>Good To Know</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.6rem, 6vw, 2.6rem)",
          color: "#FFFFFF",
          lineHeight: 1.15,
          margin: "0.75rem 0 0"
        }}>Brand questions, answered</h2>
        </div>

        <div>
          {FAQS.map((f, i) => <Item key={i} f={f} open={open === i} onClick={() => setOpen(open === i ? -1 : i)} />)}
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" /></svg>
      </div>
    </section>;
}